module.exports = __webpack_public_path__ + "assets/img/traveller-orange-neues-logo.32508a32.png";